export default "__VITE_ASSET__BLeQC6l9__"